module.exports = __webpack_public_path__ + "static/media/pdf.3d3c5429.svg";